/**
 * Checks if an item's enum status matches a specific enum value
 * @param itemStatus - The status value from the item (as a string or number)
 * @param targetStatus - The enum value to compare against
 * @param enumType - The enum type object to use for comparison
 * @returns True if the status matches
 */
export function isEnumStatus<T extends Record<string, string | number>>(
  itemStatus: string | number,
  targetStatus: T[keyof T],
  enumType: T
): boolean {
  return itemStatus.toString() === enumType[targetStatus as keyof T]?.toString();
}

/**
 * Checks if an item's enum status matches any of the provided enum values
 * @param itemStatus - The status value from the item (as a string or number)
 * @param targetStatuses - Array of enum values to compare against
 * @param enumType - The enum type object to use for comparison
 * @returns True if the status matches any of the provided statuses
 */
export function isAnyEnumStatus<T extends Record<string, string | number>>(
  itemStatus: string | number,
  targetStatuses: T[keyof T][],
  enumType: T
): boolean {
  return targetStatuses.some(status => isEnumStatus(itemStatus, status, enumType));
}
